import { Fragment, useState } from "react";
import payment from "./functions/payment";
import { Spinner } from "react-bootstrap";

function PayGrid({ numberParcel, price }) {
  const [loading, setLoading] = useState(false);

  if (!numberParcel) return <Fragment></Fragment>;

  return (
    <div>
      <p className="text-center">
        <span>مجموع قابل پرداخت:&nbsp; </span>
        <span className="text-success fs-3 fw-semibold">
          {typeof price === "number" ? price.toLocaleString() : price}
        </span>
        <span> &nbsp;ریال</span>
      </p>

      {price === 0 && (
        <p className="text-danger">
          هنوز مبلغ ارسال مرسوله شما توسط پشتیبانی تعیین نشده است
        </p>
      )}

      {price !== 0 && (
        <div>
          {loading === true && (
            <button
              className="btn-success-style btn btn-primary"
              style={{ width: 200 }}
            >
              <div className="d-flex align-items-center">
                <Spinner
                  style={{
                    width: "20px",
                    height: "20px",
                    fontSize: "0.8rem",
                  }}
                />
                <span className="me-1"> در حال هدایت به درگاه</span>
              </div>
            </button>
          )}
          {loading === false && (
            <button
              className="btn-success-style btn btn-primary"
              onClick={() =>
                payment({
                  loading: state => setLoading(state),
                  values: { numberParcel },
                })
              }
            >
              پرداخت بادرگاه بانک
            </button>
          )}
        </div>
      )}
    </div>
  );
}

export default PayGrid;
